export default "__VITE_ASSET__DpACXIqK__"